import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function FireMasterIllustration({
  achievementId,
  variant = 'blaze',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-3881" data-mp="3qxfkgim6fokb">
      
      <div className="relative w-full h-full bg-gradient-to-b from-red-900 to-stone-900 overflow-hidden" data-id="element-3882" data-mp="3vws6501baplb">
        {/* Background: Volcano and Smoke */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3883" data-mp="9o940hvd6b7o">
          
          {/* Smoke clouds */}
          <circle cx="60" cy="40" r="30" fill="#44403C" fillOpacity="0.6" filter="blur(4px)" data-id="element-3884" data-mp="2bf2nhg8h3cky" />
          
          <circle cx="140" cy="30" r="40" fill="#292524" fillOpacity="0.7" filter="blur(6px)" data-id="element-3885" data-mp="2ffmk8ip4we6k" />
          
          <circle cx="100" cy="60" r="35" fill="#57534E" fillOpacity="0.5" filter="blur(5px)" data-id="element-3886" data-mp="22ftt44y1i3bt" />
          

          {/* Embers */}
          <circle cx="50" cy="80" r="2" fill="#FDE047" data-id="element-3887" data-mp="1xnaed4nm925f" />
          <circle cx="150" cy="100" r="1.5" fill="#F97316" data-id="element-3888" data-mp="1sp8z6utb9mz8" />
          <circle cx="120" cy="50" r="2.5" fill="#EF4444" data-id="element-3889" data-mp="1sno0cszyrhvk" />
          <circle cx="80" cy="120" r="1" fill="#FDE047" data-id="element-3890" data-mp="1ns0eonkox6ut" />
        </svg>

        {/* Background: Volcano Ground */}
        <svg className="absolute bottom-0 left-0 w-full h-[40%] z-0" viewBox="0 0 200 80" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" data-id="element-3891" data-mp="2ldxta9vy8s1h">
          
          <path d="M-20 80 L60 20 L140 20 L220 80 Z" fill="#1C1917" data-id="element-3892" data-mp="2bf8l58tuulyf" />
          {/* Lava flows */}
          <path d="M70 20 Q80 50 60 80 L80 80 Q90 50 85 20 Z" fill="#EA580C" data-id="element-3893" data-mp="26g5ejjy887oc" />
          <path d="M120 20 Q110 40 130 80 L150 80 Q130 40 135 20 Z" fill="#DC2626" data-id="element-3894" data-mp="101mlgtqdd1yn" />
          
          <path d="M75 20 Q80 50 65 80 L75 80 Q85 50 80 20 Z" fill="#FDE047" data-id="element-3895" data-mp="v1iebubcpjl3" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-end justify-center pb-[10%]" data-id="element-3896" data-mp="3j7pbgp6fgblj">
          <div className="w-[70%] h-[70%] flex items-center justify-center" data-id="element-3897" data-mp="3na2dp3lytrdk">
            <DjaySpecimen look={{
            variant,
            accessory: 'doubleFlameCrown'
          }} size="hero" emotion={isUnlocked ? 'celebrating' : 'thinking'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-3898" data-mp="399rm1ycu08rc" />
            
          </div>
        </div>

        {/* Foreground: Extra Lava/Heat */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-3899" data-mp="34ayboesucxve">
          
            <path d="M0 200 L40 160 L60 200 Z" fill="#1C1917" data-id="element-3900" data-mp="2vie76xpvbz2n" />
            <path d="M160 200 L180 150 L200 200 Z" fill="#292524" data-id="element-3901" data-mp="2viwdkn68vtoa" />
            <circle cx="30" cy="180" r="4" fill="#F97316" data-id="element-3902" data-mp="2gku8g8jkf04x" />
            <circle cx="180" cy="170" r="3" fill="#EF4444" data-id="element-3903" data-mp="2gngeu4upz9lk" />
          </svg>}
      </div>
    </DjayIllustrationBase>;
}